/* eslint-disable */
import { useState, useMemo, useRef, useEffect } from "react";

// ─── Traductions ─────────────────────────────────────────────────────────────
const T = {
  fr: {
    tagline:'Vos messages. Votre impact. Notre cible.',
    // Nav
    nav_accueil:'Accueil', nav_parcourir:'Parcourir', nav_creer:'Créer annonce',
    nav_messages:'Messages', nav_favoris:'Favoris', nav_mes_annonces:'Mes annonces',
    nav_tarifs:'Tarifs', nav_profil:'Mon profil', nav_deco:'Déconnexion',
    // Auth
    connecte:'Connecté', se_connecter:'Se connecter →', pas_compte:'Pas de compte?',
    creer_compte:'Créer un compte', deja_membre:'Déjà membre?',
    essai_badge:"✨ 7 jours d'essai gratuit inclus",
    voir_tarifs:'Voir les tarifs → 19,99 $/mois',
    demo_label:'Démo :', create_title:'Créer mon compte',
    create_sub:'Rejoignez le réseau des entrepreneurs québécois',
    create_btn:'Créer mon compte →', create_pro_btn:"Démarrer mon essai gratuit →",
    pro_selected:'🎉 Plan Pro sélectionné',
    pro_selected_sub:"Créez votre compte pour démarrer votre essai de 7 jours gratuits",
    // Labels
    l_courriel:'Courriel', l_mdp:'Mot de passe', l_nom:'Nom complet', l_ville:'Ville',
    l_entreprise:'Entreprise', l_tel:'Téléphone', l_titre:"Titre de l'annonce",
    l_cat:'Catégorie', l_etat:'État', l_qte:'Quantité', l_unite:'Unité',
    l_prix:'Prix unitaire ($)', l_loc:'Ville / Région', l_desc:'Description',
    l_photos:'Photos du matériau (max. 4)',
    // Placeholders
    p_courriel:'vous@exemple.ca', p_mdp:'••••••••', p_nom:'Jean Tremblay',
    p_ville:'Montréal', p_ent:'Construction XYZ inc.', p_tel:'514-555-1234',
    p_titre:'Ex: Câble NMD90 14-2 — surplus chantier', p_qte:'100', p_prix:'25.00',
    p_loc:'Laval, QC', p_desc:'Décrivez le matériau, son origine, son état...',
    p_search:'🔍  Rechercher...', p_msg:'Tapez votre message... (Entrée pour envoyer)',
    // Boutons
    btn_publier:"📢 Publier l'annonce", btn_reset:'Réinitialiser', btn_voir:'Voir',
    btn_suppr:'Suppr.', btn_contacter:'💬 Contacter',
    btn_sauv:'🤍 Sauvegarder', btn_sauve:'❤️ Sauvegardé',
    btn_nouvelle:'➕ Nouvelle', btn_parcourir:'🔍 Parcourir',
    btn_creer_ann:'➕ Créer annonce', btn_voir_tarifs:'Voir les tarifs →',
    btn_passer_pro:'⭐ Passer à Pro', btn_retour:'← Retour aux annonces',
    btn_voir_tout:'Voir tout →', btn_premiere:'Créer ma première annonce',
    btn_parc_ann:'Parcourir les annonces', btn_suggerer:'✨ Suggérer',
    btn_analyse:'⏳...', btn_se_conn:'Se connecter',
    // Accueil
    bienvenue:'Bienvenue,', hero_title:'La marketplace des\nmatériaux de construction',
    ann_actives:'annonces', entrepreneurs:'entrepreneurs', en_favori:'en favori',
    categories:'Catégories', recentes:'Annonces récentes', voir_tout:'Voir tout →',
    ann_s:'annonce', ann_p:'annonces',
    // Annonces
    page_ann:'Parcourir les annonces', toutes_cat:'Toutes catégories',
    tous_etats:'Tous états', plus_recents:'Plus récents', prix_asc:'Prix ↑',
    prix_desc:'Prix ↓', res_s:'annonce trouvée', res_p:'annonces trouvées',
    aucun_res:'Aucun résultat', aucun_res_sub:"Essayez d'autres termes ou filtres.",
    // Plan
    plan_gratuit:'Plan Gratuit', plan_pro:'⭐ Plan Pro — Essai',
    jours_restants:'7 jours restants', passer_pro:'Passer à Pro →',
    // Détail
    publie_le:'Publié le', vues:'vues', par:'par', disponibles:'disponibles',
    valeur_est:'Valeur totale estimée', vendeur:'Vendeur', votre_ann:'Votre annonce',
    // Messages
    msg_title:'Messages', conv_s:'conversation', conv_p:'conversations',
    no_conv:'Aucune conversation.', no_conv_sub:'Contactez un vendeur depuis une annonce.',
    vous:'Vous: ', ann_label:'Annonce', select_conv:'Sélectionnez une conversation',
    demarrer:'Démarrez la conversation!', lu:' · Lu',
    // Favoris
    fav_title:'Mes favoris', no_fav:'Aucun favori',
    no_fav_sub:"Cliquez sur 🤍 d'une annonce pour la sauvegarder.",
    // Mes annonces
    mes_ann:'Mes annonces', no_ann:'Aucune annonce',
    no_ann_sub:'Publiez vos premiers surplus!',
    // Créer
    creer_title:'Créer une annonce', creer_sub:'Publiez vos surplus de matériaux de chantier',
    ia_label:'✨ IA :', ia_text:"Entrez un titre — l'IA suggère la catégorie et rédige la description.",
    apercu:'Aperçu', ajouter:'AJOUTER',
    // Profil
    profil_title:'Mon profil', tel_label:'Téléphone',
    stat_ann:'Annonces', stat_vues:'Vues', stat_fav:'Favoris', stat_val:'Valeur',
    // Tarifs
    tarifs_title:'Tarifs simples et transparents',
    tarifs_sub:'Commencez gratuitement. Passez à Pro quand vous êtes prêt.',
    no_card:'✓ Aucune carte de crédit requise pour l\'essai',
    faq_title:'Questions fréquentes', plan_actuel:'Plan actuel',
    mois:'/ mois', sur_mesure:'Sur mesure', gratuit_label:'Gratuit',
    upgrade_banner:'✨ Passez à Pro — Annonces illimitées, photos, IA et messagerie illimitée',
    // Notifs
    n_publiee:'✅ Annonce publiée!', n_supprimee:'Annonce supprimée.',
    n_champs:'Champs obligatoires manquants.', n_courriel:'Courriel déjà utilisé.',
    n_ai:'✨ Catégorie et description suggérées!', n_ai_err:'Erreur IA. Réessayez.',
    n_titre:"Entrez d'abord un titre.", n_contact:'Vous ne pouvez pas vous contacter.',
    n_login:'Courriel ou mot de passe incorrect.',
    n_ent:'Un conseiller vous contactera sous 24h!',
    n_pro:'🎉 Essai Pro activé — 7 jours gratuits!', n_grat:'Plan Gratuit activé.',
    // FAQ
    faq1q:"L'essai de 7 jours est-il vraiment gratuit?",
    faq1r:"Oui, aucune carte de crédit requise. Vous avez 7 jours pour explorer toutes les fonctionnalités Pro sans engagement.",
    faq2q:"Puis-je annuler à tout moment?",
    faq2r:"Absolument. Annulez en un clic depuis votre profil, sans frais ni pénalité.",
    faq3q:"Que se passe-t-il après l'essai?",
    faq3r:"Votre compte passe automatiquement au plan Gratuit. Vos annonces restent visibles (max 3 actives).",
    faq4q:"Le plan Entreprise est-il personnalisable?",
    faq4r:"Oui, contactez-nous pour un devis selon vos besoins : nombre d'utilisateurs, volume d'annonces, intégrations.",
  },
  en: {
    tagline:'Your messages. Your impact. Our target.',
    nav_accueil:'Home', nav_parcourir:'Browse', nav_creer:'Create listing',
    nav_messages:'Messages', nav_favoris:'Favorites', nav_mes_annonces:'My listings',
    nav_tarifs:'Pricing', nav_profil:'My profile', nav_deco:'Sign out',
    connecte:'Signed in', se_connecter:'Sign in →', pas_compte:'No account?',
    creer_compte:'Create an account', deja_membre:'Already a member?',
    essai_badge:'✨ 7-day free trial included',
    voir_tarifs:'View pricing → $19.99/month',
    demo_label:'Demo:', create_title:'Create my account',
    create_sub:'Join the Quebec contractors network',
    create_btn:'Create my account →', create_pro_btn:'Start my free trial →',
    pro_selected:'🎉 Pro plan selected',
    pro_selected_sub:'Create your account to start your 7-day free trial',
    l_courriel:'Email', l_mdp:'Password', l_nom:'Full name', l_ville:'City',
    l_entreprise:'Company', l_tel:'Phone', l_titre:'Listing title',
    l_cat:'Category', l_etat:'Condition', l_qte:'Quantity', l_unite:'Unit',
    l_prix:'Unit price ($)', l_loc:'City / Region', l_desc:'Description',
    l_photos:'Material photos (max. 4)',
    p_courriel:'you@example.ca', p_mdp:'••••••••', p_nom:'John Smith',
    p_ville:'Montreal', p_ent:'Construction XYZ inc.', p_tel:'514-555-1234',
    p_titre:'Ex: NMD90 14-2 cable — surplus', p_qte:'100', p_prix:'25.00',
    p_loc:'Laval, QC', p_desc:'Describe the material, its origin, its condition...',
    p_search:'🔍  Search...', p_msg:'Type your message... (Enter to send)',
    btn_publier:'📢 Publish listing', btn_reset:'Reset', btn_voir:'View',
    btn_suppr:'Delete', btn_contacter:'💬 Contact',
    btn_sauv:'🤍 Save', btn_sauve:'❤️ Saved',
    btn_nouvelle:'➕ New', btn_parcourir:'🔍 Browse',
    btn_creer_ann:'➕ Create listing', btn_voir_tarifs:'View pricing →',
    btn_passer_pro:'⭐ Upgrade to Pro', btn_retour:'← Back to listings',
    btn_voir_tout:'See all →', btn_premiere:'Create my first listing',
    btn_parc_ann:'Browse listings', btn_suggerer:'✨ Suggest',
    btn_analyse:'⏳...', btn_se_conn:'Sign in',
    bienvenue:'Welcome,', hero_title:'The construction\nmaterials marketplace',
    ann_actives:'listings', entrepreneurs:'contractors', en_favori:'saved',
    categories:'Categories', recentes:'Recent listings', voir_tout:'See all →',
    ann_s:'listing', ann_p:'listings',
    page_ann:'Browse listings', toutes_cat:'All categories',
    tous_etats:'All conditions', plus_recents:'Most recent', prix_asc:'Price ↑',
    prix_desc:'Price ↓', res_s:'listing found', res_p:'listings found',
    aucun_res:'No results', aucun_res_sub:'Try different terms or filters.',
    plan_gratuit:'Free Plan', plan_pro:'⭐ Pro Plan — Trial',
    jours_restants:'7 days remaining', passer_pro:'Upgrade to Pro →',
    publie_le:'Published on', vues:'views', par:'per', disponibles:'available',
    valeur_est:'Estimated total value', vendeur:'Seller', votre_ann:'Your listing',
    msg_title:'Messages', conv_s:'conversation', conv_p:'conversations',
    no_conv:'No conversations.', no_conv_sub:'Contact a seller from a listing.',
    vous:'You: ', ann_label:'Listing', select_conv:'Select a conversation',
    demarrer:'Start the conversation!', lu:' · Read',
    fav_title:'My favorites', no_fav:'No favorites',
    no_fav_sub:'Click 🤍 on a listing to save it.',
    mes_ann:'My listings', no_ann:'No listings',
    no_ann_sub:'Publish your first surplus materials!',
    creer_title:'Create a listing', creer_sub:'Publish your surplus construction materials',
    ia_label:'✨ AI:', ia_text:'Enter a title — AI suggests the category and writes the description.',
    apercu:'Preview', ajouter:'ADD',
    profil_title:'My profile', tel_label:'Phone',
    stat_ann:'Listings', stat_vues:'Views', stat_fav:'Favorites', stat_val:'Value',
    tarifs_title:'Simple, transparent pricing',
    tarifs_sub:"Start free. Upgrade to Pro when you're ready.",
    no_card:'✓ No credit card required for trial',
    faq_title:'Frequently asked questions', plan_actuel:'Current plan',
    mois:'/ month', sur_mesure:'Custom', gratuit_label:'Free',
    upgrade_banner:'✨ Upgrade to Pro — Unlimited listings, photos, AI and messaging',
    n_publiee:'✅ Listing published!', n_supprimee:'Listing deleted.',
    n_champs:'Required fields missing.', n_courriel:'Email already in use.',
    n_ai:'✨ Category and description suggested!', n_ai_err:'AI error. Please try again.',
    n_titre:'Please enter a title first.', n_contact:"You can't contact yourself.",
    n_login:'Incorrect email or password.',
    n_ent:'An advisor will contact you within 24h!',
    n_pro:'🎉 Pro trial activated — 7 days free!', n_grat:'Free plan activated.',
    faq1q:'Is the 7-day trial really free?',
    faq1r:'Yes, no credit card required. You have 7 days to explore all Pro features with no commitment.',
    faq2q:'Can I cancel at any time?',
    faq2r:'Absolutely. Cancel in one click from your profile, with no fees or penalties.',
    faq3q:'What happens after the trial?',
    faq3r:'Your account automatically switches to the Free plan. Your listings remain visible (max 3 active).',
    faq4q:'Is the Enterprise plan customizable?',
    faq4r:'Yes, contact us for a quote based on your needs: number of users, listing volume, integrations.',
  },
};

// ─── Constants ────────────────────────────────────────────────────────────────
const C = {
  bg:'#080808', sur:'#0F0F0F', card:'#161616',
  or:'#C9A84C', orL:'#E2C167', orD:'#9A7A2E',
  orBg:'rgba(201,168,76,0.07)', orBd:'rgba(201,168,76,0.22)',
  blanc:'#FFFFFF', gris:'#888', grisL:'#BBB',
  border:'rgba(255,255,255,0.07)', danger:'#E05252', vert:'#4ADE80',
};
const CATS=[
  {id:'electricite',fr:'Électricité',en:'Electrical',icon:'⚡'},
  {id:'bois',fr:'Bois & Structure',en:'Wood & Structure',icon:'🪵'},
  {id:'beton',fr:'Béton & Maçonnerie',en:'Concrete & Masonry',icon:'🧱'},
  {id:'plomberie',fr:'Plomberie',en:'Plumbing',icon:'🔧'},
  {id:'isolation',fr:'Isolation',en:'Insulation',icon:'🏠'},
  {id:'revetement',fr:'Revêtements',en:'Coverings',icon:'🪟'},
  {id:'quincaillerie',fr:'Quincaillerie',en:'Hardware',icon:'🔩'},
  {id:'equipement',fr:'Équipements',en:'Equipment',icon:'🦺'},
];
const CONDS=[
  {id:'neuf',fr:'Neuf',en:'New'},
  {id:'bon-etat',fr:'Bon état',en:'Good condition'},
  {id:'usage',fr:'Usagé',en:'Used'},
];
const UNITS=['unités/units','pi/ft','m','m²','pi²/ft²','rouleaux/rolls','bâtons/sticks','palettes/pallets','feuilles/sheets','sacs/bags','kg','tonnes','boîtes/boxes'];
const PLANS=(lang)=>[
  {
    id:'gratuit', nom:{fr:'Gratuit',en:'Free'}, prix:0, badge:null,
    desc:{fr:'Pour explorer la plateforme',en:'To explore the platform'},
    features:[
      {ok:true, fr:'Consulter toutes les annonces',en:'Browse all listings'},
      {ok:true, fr:'3 annonces actives',en:'3 active listings'},
      {ok:true, fr:'5 messages / mois',en:'5 messages / month'},
      {ok:false,fr:'Photos des matériaux',en:'Material photos'},
      {ok:false,fr:'Assistance IA',en:'AI assistance'},
      {ok:false,fr:'Annonces en vedette',en:'Featured listings'},
    ],
    cta:{fr:'Commencer gratuitement',en:'Start for free'}, highlight:false,
  },
  {
    id:'pro', nom:{fr:'Pro',en:'Pro'}, prix:19.99, badge:{fr:'7 jours gratuits',en:'7 days free'},
    desc:{fr:'Pour les entrepreneurs actifs',en:'For active contractors'},
    features:[
      {ok:true, fr:'Annonces illimitées',en:'Unlimited listings'},
      {ok:true, fr:'Photos (4 par annonce)',en:'Photos (4 per listing)'},
      {ok:true, fr:'Messagerie illimitée',en:'Unlimited messaging'},
      {ok:true, fr:'Assistance IA (catégorie + description)',en:'AI assistance (category + description)'},
      {ok:true, fr:'Favoris illimités',en:'Unlimited favorites'},
      {ok:true, fr:'Support prioritaire',en:'Priority support'},
    ],
    cta:{fr:"Démarrer l'essai gratuit",en:'Start free trial'}, highlight:true,
  },
  {
    id:'entreprise', nom:{fr:'Entreprise',en:'Enterprise'}, prix:null, badge:null,
    desc:{fr:'Pour les grandes équipes',en:'For large teams'},
    features:[
      {ok:true, fr:'Tout du plan Pro',en:'Everything in Pro'},
      {ok:true, fr:"Jusqu'à 10 utilisateurs",en:'Up to 10 users'},
      {ok:true, fr:'Tableau de bord analytics',en:'Analytics dashboard'},
      {ok:true, fr:'Badge "Entrepreneur vérifié"',en:'"Verified contractor" badge'},
      {ok:true, fr:'Intégration API',en:'API integration'},
      {ok:true, fr:'Gestionnaire de compte dédié',en:'Dedicated account manager'},
    ],
    cta:{fr:'Nous contacter',en:'Contact us'}, highlight:false,
  },
];

const condCol   = id => ({neuf:'#4ADE80','bon-etat':'#60A5FA',usage:'#888'}[id]??'#888');
const fmtP      = p  => `${parseFloat(p).toFixed(2)} $`;
const fmtD      = (d,lang) => new Date(d).toLocaleDateString(lang==='fr'?'fr-CA':'en-CA',{day:'numeric',month:'long',year:'numeric'});
const fmtH      = d  => new Date(d).toLocaleTimeString('fr-CA',{hour:'2-digit',minute:'2-digit'});
const catBg     = id => ({
  electricite:'linear-gradient(135deg,#0C1729,#152040)',bois:'linear-gradient(135deg,#1A1005,#231A08)',
  beton:'linear-gradient(135deg,#141414,#1D1D1D)',plomberie:'linear-gradient(135deg,#081820,#0A2230)',
  isolation:'linear-gradient(135deg,#081808,#0D220D)',revetement:'linear-gradient(135deg,#180C1A,#221225)',
  quincaillerie:'linear-gradient(135deg,#181808,#201E0A)',equipement:'linear-gradient(135deg,#180A0A,#220C0C)',
}[id]??'linear-gradient(135deg,#121212,#1A1A1A)');

const USERS0=[
  {id:1,nom:'Precylia Morin',entreprise:'Hunter Mécanique du Bâtiment',telephone:'514-555-0101',email:'precylia1991@gmail.com',password:'test',ville:'Laval'},
  {id:2,nom:'Marc Tremblay',entreprise:'Électro-Pro MT',telephone:'450-555-0202',email:'marc@electropro.ca',password:'test',ville:'Laval'},
  {id:3,nom:'Julie Bélanger',entreprise:'Construction Bélanger',telephone:'514-555-0303',email:'julie@belanger.ca',password:'test',ville:'Montréal'},
];
const LISTS0=[
  {id:1,title:'Câble NMD90 14-2 — 250 m',category:'electricite',price:180,quantity:5,unit:'rouleaux/rolls',condition:'neuf',location:'Laval, QC',description:'Surplus de chantier. Rouleaux de 250 m, câble NMD90 14-2 AWG. Jamais ouverts.',sellerId:2,date:'2026-07-10',views:23,photos:[]},
  {id:2,title:'Contreplaqué 4×8 ¾ po',category:'bois',price:38,quantity:40,unit:'feuilles/sheets',condition:'neuf',location:'Montréal, QC',description:"40 feuilles contreplaqué 4×8 po, ¾ po, grade construction. Surplus chantier condo.",sellerId:3,date:'2026-07-15',views:41,photos:[]},
  {id:3,title:'Blocs de béton 8 po standard',category:'beton',price:2.5,quantity:300,unit:'unités/units',condition:'neuf',location:'Terrebonne, QC',description:'Blocs de béton 8 po. Palette complète. Fin de projet habitation sociale.',sellerId:3,date:'2026-07-18',views:15,photos:[]},
  {id:4,title:'Isolant XPS 2 po — R10',category:'isolation',price:25,quantity:60,unit:'panneaux',condition:'neuf',location:'Québec, QC',description:'Panneaux 4×8 po isolant XPS 2 po (R10). Surplus toiture. Owens Corning.',sellerId:2,date:'2026-07-20',views:8,photos:[]},
  {id:5,title:'Conduit EMT 1 po — 10 pi',category:'electricite',price:8,quantity:120,unit:'bâtons/sticks',condition:'neuf',location:'Laval, QC',description:'Conduit EMT 1 po, longueur 10 pi. Surplus projet commercial. Excellent état.',sellerId:2,date:'2026-07-21',views:30,photos:[]},
  {id:6,title:'Portes intérieures préhung 32 po',category:'revetement',price:95,quantity:12,unit:'unités/units',condition:'bon-etat',location:'Longueuil, QC',description:"Portes préhung 32×80 po, bois d'ingénierie. Légèrement rayées, fonctionnelles.",sellerId:3,date:'2026-07-22',views:19,photos:[]},
];
const CONVOS0=[
  {id:1,listingId:1,buyerId:1,sellerId:2,messages:[
    {id:1,senderId:2,text:'Bonjour! Le câble NMD90 est-il encore disponible?',date:'2026-07-21T10:00:00',read:true},
    {id:2,senderId:1,text:'Oui, absolument! 5 rouleaux disponibles à Laval.',date:'2026-07-21T10:15:00',read:true},
    {id:3,senderId:2,text:'Super! Je peux passer ce samedi matin?',date:'2026-07-21T10:22:00',read:false},
  ]},
];

async function aiAssist(title,desc) {
  const r=await fetch("https://api.anthropic.com/v1/messages",{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({model:'claude-sonnet-4-6',max_tokens:400,messages:[{role:'user',content:`Marketplace matériaux construction Québec. Matériau: "${title}"${desc?`. Description: "${desc}"`:''}. JSON seulement sans backticks: {"category":"...","description":"...2-3 phrases pro français..."}. Catégories: electricite,bois,beton,plomberie,isolation,revetement,quincaillerie,equipement`}]})});
  const d=await r.json();
  return JSON.parse(d.content.map(b=>b.text||'').join('').trim());
}

function CibleLogo({size=30}) {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none">
      <defs><linearGradient id="cg" x1="0" y1="0" x2="30" y2="30" gradientUnits="userSpaceOnUse"><stop offset="0%" stopColor="#E2C167"/><stop offset="100%" stopColor="#9A7A2E"/></linearGradient></defs>
      <circle cx="15" cy="15" r="13.5" stroke="url(#cg)" strokeWidth="1.3" fill="none"/>
      <circle cx="15" cy="15" r="9.5" stroke="url(#cg)" strokeWidth="0.8" fill="none"/>
      <line x1="15" y1="1" x2="15" y2="5.5" stroke="url(#cg)" strokeWidth="2" strokeLinecap="round"/>
      <line x1="15" y1="24.5" x2="15" y2="29" stroke="url(#cg)" strokeWidth="2" strokeLinecap="round"/>
      <line x1="1" y1="15" x2="5.5" y2="15" stroke="url(#cg)" strokeWidth="2" strokeLinecap="round"/>
      <line x1="24.5" y1="15" x2="29" y2="15" stroke="url(#cg)" strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 8A9 9 0 1 0 20 22" stroke="white" strokeWidth="2.8" fill="none" strokeLinecap="round"/>
      <circle cx="15" cy="15" r="2.8" fill="url(#cg)"/>
    </svg>
  );
}

const LS={display:'block',fontSize:11,fontWeight:600,color:'#888',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.08em'};
const IS={width:'100%',padding:'11px 14px',border:'1px solid rgba(255,255,255,0.07)',borderRadius:8,fontSize:14,color:'#fff',background:'#0A0A0A',outline:'none',boxSizing:'border-box',fontFamily:'inherit'};

function Inp({label,value,onChange,type='text',placeholder='',req=false}) {
  const [f,setF]=useState(false);
  return (
    <div style={{marginBottom:16}}>
      <label style={LS}>{label}{req&&<span style={{color:'#C9A84C'}}> *</span>}</label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        onFocus={()=>setF(true)} onBlur={()=>setF(false)}
        style={{...IS,border:`1px solid ${f?'rgba(201,168,76,0.4)':'rgba(255,255,255,0.07)'}`}}/>
    </div>
  );
}
function Sel({label,value,onChange,opts,ph='Choisir...',req=false}) {
  return (
    <div style={{marginBottom:16}}>
      <label style={LS}>{label}{req&&<span style={{color:'#C9A84C'}}> *</span>}</label>
      <select value={value} onChange={e=>onChange(e.target.value)} style={{...IS,cursor:'pointer'}}>
        <option value="">{ph}</option>
        {opts.map(o=><option key={o.v??o} value={o.v??o} style={{background:'#1A1A1A'}}>{o.l??o}</option>)}
      </select>
    </div>
  );
}
const BV={
  or:{background:'linear-gradient(135deg,#E2C167,#9A7A2E)',color:'#060606',border:'none'},
  ghost:{background:'transparent',color:'#BBB',border:'1px solid rgba(255,255,255,0.1)'},
  red:{background:'rgba(224,82,82,0.1)',color:'#E05252',border:'1px solid rgba(224,82,82,0.2)'},
};
function Btn({children,onClick,variant='or',sm=false,full=false,dis=false}) {
  return (
    <button onClick={onClick} disabled={dis}
      style={{...BV[variant],padding:sm?'6px 14px':'10px 20px',borderRadius:8,fontSize:sm?12:13,fontWeight:700,cursor:dis?'default':'pointer',width:full?'100%':'auto',opacity:dis?0.5:1,transition:'opacity 0.15s'}}
      onMouseEnter={e=>!dis&&(e.currentTarget.style.opacity='0.8')}
      onMouseLeave={e=>e.currentTarget.style.opacity='1'}>
      {children}
    </button>
  );
}
function Tag({children,bg=C.orBg,tc=C.or,bd=C.orBd}) {
  return <span style={{background:bg,color:tc,border:`1px solid ${bd}`,padding:'3px 10px',borderRadius:20,fontSize:11,fontWeight:600,whiteSpace:'nowrap'}}>{children}</span>;
}
function Card({listing:l,seller,onOpen,isFav,onFav,lang}) {
  const [hov,setHov]=useState(false);
  const photo=l.photos?.[0];
  const cat=CATS.find(c=>c.id===l.category);
  const cond=CONDS.find(c=>c.id===l.condition);
  return (
    <div onClick={()=>onOpen(l.id)}
      style={{background:hov?'#161616':'#0F0F0F',borderRadius:12,cursor:'pointer',border:`1px solid ${hov?'rgba(201,168,76,0.22)':'rgba(255,255,255,0.07)'}`,transition:'all 0.18s',boxShadow:hov?'0 8px 32px rgba(201,168,76,0.1)':'',overflow:'hidden'}}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}>
      <div style={{height:118,position:'relative',overflow:'hidden'}}>
        {photo?<img src={photo} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
          :<div style={{width:'100%',height:'100%',background:catBg(l.category),display:'flex',alignItems:'center',justifyContent:'center'}}><span style={{fontSize:36,opacity:0.3}}>{cat?.icon}</span></div>}
        <button onClick={e=>{e.stopPropagation();onFav(l.id);}}
          style={{position:'absolute',top:7,right:7,width:26,height:26,borderRadius:'50%',background:'rgba(0,0,0,0.6)',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,backdropFilter:'blur(4px)'}}>
          {isFav?'❤️':'🤍'}
        </button>
        <div style={{position:'absolute',bottom:7,left:8}}>
          <span style={{background:`${condCol(l.condition)}20`,color:condCol(l.condition),border:`1px solid ${condCol(l.condition)}35`,padding:'2px 7px',borderRadius:10,fontSize:10,fontWeight:700}}>{cond?.[lang]}</span>
        </div>
      </div>
      <div style={{padding:14}}>
        <h3 style={{fontSize:13,fontWeight:700,color:'#fff',margin:'0 0 5px',lineHeight:1.3}}>{l.title}</h3>
        <p style={{fontSize:11,color:'#888',margin:'0 0 9px',lineHeight:1.45,display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{l.description}</p>
        <div style={{display:'flex',gap:4,flexWrap:'wrap',marginBottom:9}}>
          <Tag>{cat?.[lang]}</Tag>
          <Tag bg='rgba(255,255,255,0.04)' tc='#999' bd='rgba(255,255,255,0.06)'>📍 {l.location}</Tag>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',paddingTop:9,borderTop:'1px solid rgba(255,255,255,0.06)'}}>
          <div><span style={{fontSize:16,fontWeight:800,color:'#C9A84C'}}>{fmtP(l.price)}</span><span style={{fontSize:10,color:'#888'}}> /{l.unit}</span></div>
          <div style={{textAlign:'right'}}><div style={{fontSize:10,color:'#BBB',fontWeight:500}}>{seller?.entreprise}</div><div style={{fontSize:10,color:'#888'}}>Qté: {l.quantity}</div></div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [view,setView]       = useState('login');
  const [lang,setLang]       = useState('fr');
  const [user,setUser]       = useState(null);
  const [users,setUsers]     = useState(USERS0);
  const [lists,setLists]     = useState(LISTS0);
  const [selId,setSelId]     = useState(null);
  const [notif,setNotif]     = useState(null);
  const [srch,setSrch]       = useState('');
  const [flt,setFlt]         = useState({cat:'',cond:'',sort:'recent'});
  const [aiLoad,setAiLoad]   = useState(false);
  const [lgF,setLgF]         = useState({email:'',password:''});
  const [rgF,setRgF]         = useState({nom:'',entreprise:'',telephone:'',email:'',password:'',ville:''});
  const [nlF,setNlF]         = useState({title:'',category:'',quantity:'',unit:'unités/units',price:'',condition:'neuf',location:'',description:'',photos:[]});
  const [convos,setConvos]   = useState(CONVOS0);
  const [acId,setAcId]       = useState(null);
  const [msgText,setMsgText] = useState('');
  const [favs,setFavs]       = useState([4]);
  const [gallery,setGallery] = useState(0);
  const [userPlan,setUserPlan]= useState('gratuit');
  const msgEnd = useRef(null);
  useEffect(()=>{ msgEnd.current?.scrollIntoView({behavior:'smooth'}); },[acId,convos]);

  // Translation shortcut
  const $  = key => T[lang]?.[key] ?? T.fr[key] ?? key;
  const getUser  = id => users.find(u=>u.id===id);
  const selL     = lists.find(l=>l.id===selId);
  const blankNl  = () => setNlF({title:'',category:'',quantity:'',unit:'unités/units',price:'',condition:'neuf',location:'',description:'',photos:[]});
  const go       = (v,id=null) => { if(id!==null){setSelId(id);setGallery(0);} setView(v); };
  const unread   = user ? convos.filter(c=>c.buyerId===user.id||c.sellerId===user.id).reduce((s,c)=>s+c.messages.filter(m=>m.senderId!==user.id&&!m.read).length,0) : 0;
  const catLabel = id => CATS.find(c=>c.id===id)?.[lang] ?? id;
  const condLabel= id => CONDS.find(c=>c.id===id)?.[lang] ?? id;
  const plans    = PLANS(lang);

  const filtered = useMemo(()=>{
    let r=[...lists];
    if(srch) r=r.filter(l=>[l.title,l.description,l.location].join(' ').toLowerCase().includes(srch.toLowerCase()));
    if(flt.cat)  r=r.filter(l=>l.category===flt.cat);
    if(flt.cond) r=r.filter(l=>l.condition===flt.cond);
    if(flt.sort==='recent')   r.sort((a,b)=>new Date(b.date)-new Date(a.date));
    if(flt.sort==='prix-asc') r.sort((a,b)=>a.price-b.price);
    if(flt.sort==='prix-desc')r.sort((a,b)=>b.price-a.price);
    return r;
  },[lists,srch,flt]);

  const notify = (msg,type='ok') => { setNotif({msg,type}); setTimeout(()=>setNotif(null),3500); };

  const handleLogin = () => {
    const u=users.find(u=>u.email===lgF.email&&u.password===lgF.password);
    u?(setUser(u),setView('accueil')):notify($('n_login'),'err');
  };
  const handleRegister = () => {
    if(!rgF.nom||!rgF.email||!rgF.password){notify($('n_champs'),'err');return;}
    if(users.find(u=>u.email===rgF.email)){notify($('n_courriel'),'err');return;}
    const nu={...rgF,id:Date.now()};
    setUsers(p=>[...p,nu]);setUser(nu);setView('accueil');
    notify(`${lang==='fr'?'Bienvenue':'Welcome'}, ${nu.nom}!`);
  };
  const handleLogout  = () => { setUser(null);setUserPlan('gratuit');setView('login'); };
  const handleCreate  = () => {
    if(!nlF.title||!nlF.category||!nlF.price||!nlF.quantity||!nlF.location){notify($('n_champs'),'err');return;}
    const nl={...nlF,id:Date.now(),sellerId:user.id,date:new Date().toISOString().slice(0,10),views:0,price:parseFloat(nlF.price),quantity:parseInt(nlF.quantity)};
    setLists(p=>[nl,...p]);blankNl();go('mes-annonces');notify($('n_publiee'));
  };
  const handleDelete  = id => { setLists(p=>p.filter(l=>l.id!==id));notify($('n_supprimee')); };
  const handleAI      = async () => {
    if(!nlF.title){notify($('n_titre'),'err');return;}
    setAiLoad(true);
    try{const r=await aiAssist(nlF.title,nlF.description);setNlF(p=>({...p,category:r.category||p.category,description:r.description||p.description}));notify($('n_ai'));}
    catch(e){notify($('n_ai_err'),'err');}
    setAiLoad(false);
  };
  const handlePhotos  = files => Array.from(files).slice(0,4-nlF.photos.length).forEach(f=>{
    const r=new FileReader();r.onload=e=>setNlF(p=>({...p,photos:[...p.photos,e.target.result]}));r.readAsDataURL(f);
  });
  const removePhoto   = i => setNlF(p=>({...p,photos:p.photos.filter((_,j)=>j!==i)}));
  const toggleFav     = id => setFavs(p=>p.includes(id)?p.filter(f=>f!==id):[...p,id]);
  const contactSeller = listing => {
    if(!user||listing.sellerId===user.id){notify($('n_contact'),'err');return;}
    let c=convos.find(c=>c.listingId===listing.id&&((c.buyerId===user.id&&c.sellerId===listing.sellerId)||(c.sellerId===user.id&&c.buyerId===listing.sellerId)));
    if(!c){c={id:Date.now(),listingId:listing.id,buyerId:user.id,sellerId:listing.sellerId,messages:[]};setConvos(p=>[...p,c]);}
    setAcId(c.id);setView('messages');
  };
  const openConvo = id => { setAcId(id);setConvos(p=>p.map(c=>c.id===id?{...c,messages:c.messages.map(m=>m.senderId!==user.id?{...m,read:true}:m)}:c)); };
  const sendMsg   = () => {
    if(!msgText.trim()||!acId)return;
    const m={id:Date.now(),senderId:user.id,text:msgText.trim(),date:new Date().toISOString(),read:false};
    setConvos(p=>p.map(c=>c.id===acId?{...c,messages:[...c.messages,m]}:c));setMsgText('');
  };
  const choisirPlan = id => {
    if(id==='entreprise'){notify($('n_ent'));return;}
    setUserPlan(id);
    notify(id==='pro'?$('n_pro'):$('n_grat'));
    if(user) setView('accueil'); else setView('register');
  };

  // ── Shared ──────────────────────────────────────────────────────────────────
  const notifEl = notif&&(
    <div style={{position:'fixed',top:20,right:20,zIndex:9999,background:notif.type==='err'?'rgba(220,60,60,0.96)':'rgba(50,150,90,0.96)',color:'#fff',padding:'12px 20px',borderRadius:10,fontWeight:600,fontSize:13,boxShadow:'0 4px 30px rgba(0,0,0,0.5)',maxWidth:300,border:'1px solid rgba(255,255,255,0.1)'}}>
      {notif.msg}
    </div>
  );

  // Language switcher
  const langSwitcher = (
    <div style={{display:'flex',gap:4,padding:'6px 10px',borderBottom:'1px solid rgba(255,255,255,0.06)'}}>
      {['fr','en'].map(l=>(
        <button key={l} onClick={()=>setLang(l)}
          style={{flex:1,padding:'5px 0',borderRadius:6,border:`1px solid ${lang===l?C.orBd:'rgba(255,255,255,0.07)'}`,background:lang===l?C.orBg:'transparent',color:lang===l?C.or:'#666',fontSize:11,fontWeight:lang===l?700:500,cursor:'pointer',transition:'all 0.15s'}}>
          {l==='fr'?'🇫🇷 FR':'🇬🇧 EN'}
        </button>
      ))}
    </div>
  );

  const planBadge = (
    <div style={{margin:'6px 8px 0',padding:'6px 10px',background:userPlan==='pro'?C.orBg:'rgba(255,255,255,0.04)',border:`1px solid ${userPlan==='pro'?C.orBd:'rgba(255,255,255,0.07)'}`,borderRadius:8,cursor:'pointer'}} onClick={()=>setView('tarifs')}>
      <div style={{fontSize:9,color:userPlan==='pro'?C.or:'#666',textTransform:'uppercase',letterSpacing:'0.1em',fontWeight:700}}>{userPlan==='pro'?$('plan_pro'):$('plan_gratuit')}</div>
      <div style={{fontSize:10,color:userPlan==='pro'?C.orL:'#888',marginTop:1}}>{userPlan==='pro'?$('jours_restants'):$('passer_pro')}</div>
    </div>
  );

  const NAV=[
    {id:'accueil',icon:'🏠',label:$('nav_accueil')},
    {id:'annonces',icon:'🔍',label:$('nav_parcourir')},
    {id:'creer',icon:'➕',label:$('nav_creer')},
    {id:'messages',icon:'💬',label:$('nav_messages'),badge:unread},
    {id:'favoris',icon:'❤️',label:$('nav_favoris'),badge:favs.length},
    {id:'mes-annonces',icon:'📋',label:$('nav_mes_annonces')},
    {id:'tarifs',icon:'💳',label:$('nav_tarifs')},
    {id:'profil',icon:'👤',label:$('nav_profil')},
  ];

  const iStyle={padding:'9px 10px',border:'1px solid rgba(255,255,255,0.07)',borderRadius:8,fontSize:12,background:'#0A0A0A',cursor:'pointer',fontFamily:'inherit',color:'#BBB',outline:'none'};

  const sidebar=(
    <div style={{width:210,minWidth:210,background:'#080808',height:'100vh',position:'sticky',top:0,display:'flex',flexDirection:'column',flexShrink:0,borderRight:'1px solid rgba(255,255,255,0.06)'}}>
      <div style={{padding:'18px 16px 14px',borderBottom:'1px solid rgba(255,255,255,0.06)'}}>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <CibleLogo size={30}/>
          <div>
            <div style={{fontWeight:900,fontSize:13,letterSpacing:'0.05em'}}><span style={{color:'#fff'}}>CIBLE</span><span style={{background:'linear-gradient(90deg,#E2C167,#9A7A2E)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>MAX</span></div>
            <div style={{fontSize:8,color:'#666',letterSpacing:'0.08em',marginTop:1}}>{$('tagline').split('.')[0].toUpperCase()}</div>
          </div>
        </div>
      </div>
      {/* Language switcher */}
      {langSwitcher}
      {user&&<div style={{padding:'9px 16px 2px',borderBottom:'1px solid rgba(255,255,255,0.06)',paddingBottom:10}}>
        <div style={{fontSize:9,color:'#555',marginBottom:2,textTransform:'uppercase',letterSpacing:'0.1em'}}>{$('connecte')}</div>
        <div style={{fontSize:12,color:'#fff',fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user.nom}</div>
        <div style={{fontSize:10,color:'#C9A84C',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user.entreprise}</div>
        {planBadge}
      </div>}
      <nav style={{padding:'7px',flex:1,overflow:'auto'}}>
        {NAV.map(i=>(
          <button key={i.id} onClick={()=>setView(i.id)}
            style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%',padding:'8px 10px',marginBottom:2,background:view===i.id?'rgba(201,168,76,0.08)':'transparent',border:view===i.id?'1px solid rgba(201,168,76,0.2)':'1px solid transparent',borderRadius:7,cursor:'pointer',transition:'all 0.12s'}}>
            <div style={{display:'flex',alignItems:'center',gap:8,color:view===i.id?'#C9A84C':'#777',fontSize:12,fontWeight:view===i.id?700:400}}>
              <span style={{fontSize:13}}>{i.icon}</span>{i.label}
            </div>
            {i.badge>0&&<span style={{background:view===i.id?'#C9A84C':'#E05252',color:'#080808',borderRadius:9,padding:'1px 5px',fontSize:10,fontWeight:800}}>{i.badge}</span>}
          </button>
        ))}
      </nav>
      <div style={{padding:'7px',borderTop:'1px solid rgba(255,255,255,0.06)'}}>
        <button onClick={handleLogout} style={{display:'flex',alignItems:'center',gap:8,width:'100%',padding:'8px 10px',background:'transparent',border:'1px solid transparent',borderRadius:7,cursor:'pointer',color:'#555',fontSize:12,textAlign:'left'}}>
          🚪 {$('nav_deco')}
        </button>
      </div>
    </div>
  );

  const wrap = c => (
    <div style={{display:'flex',minHeight:'100vh',background:'#080808',fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',color:'#fff'}}>
      {notifEl}{sidebar}<div style={{flex:1,overflow:'auto',minWidth:0}}>{c}</div>
    </div>
  );
  const authWrap = c => (
    <div style={{minHeight:'100vh',background:'#080808',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',padding:20,position:'relative'}}>
      {notifEl}
      <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:500,height:500,background:'radial-gradient(circle,rgba(201,168,76,0.05),transparent 70%)',pointerEvents:'none'}}/>
      {/* Lang switcher on auth pages */}
      <div style={{position:'absolute',top:16,right:20,display:'flex',gap:6}}>
        {['fr','en'].map(l=>(
          <button key={l} onClick={()=>setLang(l)}
            style={{padding:'4px 10px',borderRadius:20,border:`1px solid ${lang===l?C.orBd:'rgba(255,255,255,0.1)'}`,background:lang===l?C.orBg:'transparent',color:lang===l?C.or:'#888',fontSize:11,fontWeight:lang===l?700:400,cursor:'pointer'}}>
            {l==='fr'?'🇫🇷 FR':'🇬🇧 EN'}
          </button>
        ))}
      </div>
      {c}
    </div>
  );

  // ═══ LOGIN ═══
  if(view==='login') return authWrap(
    <div style={{background:'#0F0F0F',borderRadius:14,padding:38,width:390,maxWidth:'100%',boxShadow:'0 24px 80px rgba(0,0,0,0.8)',border:'1px solid rgba(255,255,255,0.07)',position:'relative',zIndex:1}}>
      <div style={{textAlign:'center',marginBottom:28}}>
        <div style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:60,height:60,background:'rgba(201,168,76,0.08)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:14,marginBottom:14}}><CibleLogo size={36}/></div>
        <h1 style={{fontSize:21,fontWeight:900,margin:'0 0 4px',letterSpacing:'0.04em'}}><span style={{color:'#fff'}}>CIBLE</span><span style={{background:'linear-gradient(90deg,#E2C167,#9A7A2E)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>MAX</span></h1>
        <p style={{fontSize:10,color:'#666',margin:0,letterSpacing:'0.12em',textTransform:'uppercase'}}>{$('tagline')}</p>
        <div style={{display:'inline-flex',alignItems:'center',gap:6,background:'rgba(201,168,76,0.08)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:20,padding:'4px 12px',marginTop:12,fontSize:12,color:'#C9A84C',fontWeight:600}}>{$('essai_badge')}</div>
      </div>
      <Inp label={$('l_courriel')} value={lgF.email} onChange={v=>setLgF(p=>({...p,email:v}))} type="email" placeholder={$('p_courriel')} req/>
      <Inp label={$('l_mdp')} value={lgF.password} onChange={v=>setLgF(p=>({...p,password:v}))} type="password" placeholder={$('p_mdp')} req/>
      <div style={{marginBottom:14}}><Btn onClick={handleLogin} full>{$('se_connecter')}</Btn></div>
      <p style={{textAlign:'center',fontSize:12,color:'#666',margin:'0 0 8px'}}>{$('pas_compte')}{' '}<button onClick={()=>setView('register')} style={{background:'none',border:'none',color:'#C9A84C',fontWeight:700,cursor:'pointer',fontSize:12,padding:0}}>{$('creer_compte')}</button></p>
      <button onClick={()=>setView('tarifs')} style={{display:'block',width:'100%',textAlign:'center',background:'none',border:'none',color:'#888',fontSize:11,cursor:'pointer',padding:'4px 0'}}>{$('voir_tarifs')}</button>
      <div style={{marginTop:12,padding:10,background:'rgba(201,168,76,0.06)',borderRadius:8,fontSize:11,color:'#C9A84C',border:'1px solid rgba(201,168,76,0.18)',lineHeight:1.5}}>💡 <strong>{$('demo_label')}</strong> precylia1991@gmail.com / test</div>
    </div>
  );

  // ═══ REGISTER ═══
  if(view==='register') return authWrap(
    <div style={{background:'#0F0F0F',borderRadius:14,padding:38,width:480,maxWidth:'100%',boxShadow:'0 24px 80px rgba(0,0,0,0.8)',border:'1px solid rgba(255,255,255,0.07)',position:'relative',zIndex:1}}>
      {userPlan==='pro'&&<div style={{background:'rgba(201,168,76,0.08)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:10,padding:'10px 14px',marginBottom:16,textAlign:'center'}}>
        <div style={{fontSize:13,color:'#E2C167',fontWeight:700}}>{$('pro_selected')}</div>
        <div style={{fontSize:11,color:'#C9A84C',marginTop:2}}>{$('pro_selected_sub')}</div>
      </div>}
      <div style={{textAlign:'center',marginBottom:20}}><h1 style={{fontSize:19,fontWeight:900,margin:'0 0 4px'}}>{$('create_title')}</h1><p style={{fontSize:11,color:'#777',margin:0}}>{$('create_sub')}</p></div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 12px'}}>
        <Inp label={$('l_nom')} value={rgF.nom} onChange={v=>setRgF(p=>({...p,nom:v}))} placeholder={$('p_nom')} req/>
        <Inp label={$('l_ville')} value={rgF.ville} onChange={v=>setRgF(p=>({...p,ville:v}))} placeholder={$('p_ville')}/>
      </div>
      <Inp label={$('l_entreprise')} value={rgF.entreprise} onChange={v=>setRgF(p=>({...p,entreprise:v}))} placeholder={$('p_ent')}/>
      <Inp label={$('l_tel')} value={rgF.telephone} onChange={v=>setRgF(p=>({...p,telephone:v}))} placeholder={$('p_tel')}/>
      <Inp label={$('l_courriel')} value={rgF.email} onChange={v=>setRgF(p=>({...p,email:v}))} type="email" placeholder={$('p_courriel')} req/>
      <Inp label={$('l_mdp')} value={rgF.password} onChange={v=>setRgF(p=>({...p,password:v}))} type="password" placeholder={$('p_mdp')} req/>
      <div style={{marginBottom:14}}><Btn onClick={handleRegister} full>{userPlan==='pro'?$('create_pro_btn'):$('create_btn')}</Btn></div>
      <p style={{textAlign:'center',fontSize:12,color:'#666',margin:0}}>{$('deja_membre')}{' '}<button onClick={()=>setView('login')} style={{background:'none',border:'none',color:'#C9A84C',fontWeight:700,cursor:'pointer',fontSize:12,padding:0}}>{$('btn_se_conn')}</button></p>
    </div>
  );

  // ═══ ACCUEIL ═══
  if(view==='accueil') return wrap(<>
    {userPlan==='gratuit'&&<div style={{background:'linear-gradient(90deg,rgba(201,168,76,0.07),rgba(201,168,76,0.12))',borderBottom:'1px solid rgba(201,168,76,0.2)',padding:'10px 32px',display:'flex',justifyContent:'space-between',alignItems:'center',gap:12}}>
      <span style={{fontSize:12,color:'#C9A84C'}}>✨ <strong>{lang==='fr'?'Passez à Pro':'Upgrade to Pro'}</strong> — {lang==='fr'?'Annonces illimitées, photos, IA et messagerie illimitée':'Unlimited listings, photos, AI and messaging'}</span>
      <Btn onClick={()=>setView('tarifs')} sm>{$('btn_voir_tarifs')}</Btn>
    </div>}
    <div style={{padding:'30px 32px',position:'relative',overflow:'hidden',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
      <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse 60% 120% at 80% 50%,rgba(201,168,76,0.055),transparent)',pointerEvents:'none'}}/>
      <div style={{position:'absolute',top:'50%',right:60,transform:'translateY(-50%)',opacity:0.025,pointerEvents:'none'}}><CibleLogo size={200}/></div>
      <div style={{position:'relative'}}>
        <div style={{display:'inline-block',background:C.orBg,border:`1px solid ${C.orBd}`,borderRadius:20,padding:'3px 12px',fontSize:10,color:'#C9A84C',fontWeight:600,letterSpacing:'0.12em',textTransform:'uppercase',marginBottom:12}}>{$('bienvenue')} {user?.nom?.split(' ')[0]}</div>
        <h2 style={{fontSize:24,fontWeight:900,margin:'0 0 8px',lineHeight:1.2}}>{$('hero_title').split('\n').map((l,i)=><span key={i}>{l}{i===0&&<br/>}</span>)}</h2>
        <p style={{color:'#777',fontSize:13,margin:'0 0 20px'}}>{lists.length} {$('ann_actives')} · {users.length} {$('entrepreneurs')} · {favs.length} {$('en_favori')}</p>
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          <Btn onClick={()=>setView('annonces')}>{$('btn_parcourir')}</Btn>
          <Btn onClick={()=>setView('creer')} variant="ghost">{$('btn_creer_ann')}</Btn>
        </div>
      </div>
    </div>
    <div style={{padding:'22px 32px'}}>
      <h3 style={{fontSize:10,fontWeight:700,color:'#666',margin:'0 0 10px',textTransform:'uppercase',letterSpacing:'0.12em'}}>{$('categories')}</h3>
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:7,marginBottom:26}}>
        {CATS.map(cat=>{
          const cnt=lists.filter(l=>l.category===cat.id).length;
          return <button key={cat.id} onClick={()=>{setFlt(p=>({...p,cat:cat.id}));setView('annonces');}}
            style={{background:'#0F0F0F',border:'1px solid rgba(255,255,255,0.07)',borderRadius:9,padding:'11px 7px',cursor:'pointer',textAlign:'center',transition:'all 0.15s',outline:'none'}}
            onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(201,168,76,0.3)';e.currentTarget.style.background='rgba(201,168,76,0.05)';}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(255,255,255,0.07)';e.currentTarget.style.background='#0F0F0F';}}>
            <div style={{fontSize:20,marginBottom:4}}>{cat.icon}</div>
            <div style={{fontSize:10,fontWeight:600,color:'#BBB'}}>{cat[lang]}</div>
            <div style={{fontSize:9,color:'#666',marginTop:2}}>{cnt} {cnt!==1?$('ann_p'):$('ann_s')}</div>
          </button>;
        })}
      </div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
        <h3 style={{fontSize:10,fontWeight:700,color:'#666',margin:0,textTransform:'uppercase',letterSpacing:'0.12em'}}>{$('recentes')}</h3>
        <button onClick={()=>setView('annonces')} style={{background:'none',border:'none',color:'#C9A84C',fontWeight:600,cursor:'pointer',fontSize:11,padding:0}}>{$('btn_voir_tout')}</button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:9}}>
        {[...lists].sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,6).map(l=>(
          <Card key={l.id} listing={l} seller={getUser(l.sellerId)} onOpen={id=>go('detail',id)} isFav={favs.includes(l.id)} onFav={toggleFav} lang={lang}/>
        ))}
      </div>
    </div>
  </>);

  // ═══ ANNONCES ═══
  if(view==='annonces') return wrap(
    <div style={{padding:'22px 32px'}}>
      <h2 style={{fontSize:17,fontWeight:800,margin:'0 0 14px'}}>{$('page_ann')}</h2>
      <div style={{display:'flex',gap:7,marginBottom:12,flexWrap:'wrap'}}>
        <input value={srch} onChange={e=>setSrch(e.target.value)} placeholder={$('p_search')} style={{flex:'1 1 200px',...iStyle}}/>
        <select value={flt.cat} onChange={e=>setFlt(p=>({...p,cat:e.target.value}))} style={iStyle}>
          <option value="">{$('toutes_cat')}</option>
          {CATS.map(c=><option key={c.id} value={c.id} style={{background:'#1A1A1A'}}>{c.icon} {c[lang]}</option>)}
        </select>
        <select value={flt.cond} onChange={e=>setFlt(p=>({...p,cond:e.target.value}))} style={iStyle}>
          <option value="">{$('tous_etats')}</option>
          {CONDS.map(c=><option key={c.id} value={c.id} style={{background:'#1A1A1A'}}>{c[lang]}</option>)}
        </select>
        <select value={flt.sort} onChange={e=>setFlt(p=>({...p,sort:e.target.value}))} style={iStyle}>
          <option value="recent">{$('plus_recents')}</option>
          <option value="prix-asc">{$('prix_asc')}</option>
          <option value="prix-desc">{$('prix_desc')}</option>
        </select>
        {(srch||flt.cat||flt.cond)&&<button onClick={()=>{setSrch('');setFlt({cat:'',cond:'',sort:'recent'});}} style={{...iStyle,background:C.orBg,color:C.or,border:`1px solid ${C.orBd}`,fontWeight:700}}>✕</button>}
      </div>
      <p style={{fontSize:11,color:'#666',marginBottom:10}}>{filtered.length} {filtered.length!==1?$('res_p'):$('res_s')}</p>
      {filtered.length===0
        ?<div style={{textAlign:'center',padding:50,color:'#777'}}><div style={{fontSize:36,marginBottom:8}}>🔍</div><h3 style={{color:'#BBB',margin:'0 0 5px'}}>{$('aucun_res')}</h3><p style={{margin:0,fontSize:12}}>{$('aucun_res_sub')}</p></div>
        :<div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:9}}>
          {filtered.map(l=><Card key={l.id} listing={l} seller={getUser(l.sellerId)} onOpen={id=>go('detail',id)} isFav={favs.includes(l.id)} onFav={toggleFav} lang={lang}/>)}
        </div>
      }
    </div>
  );

  // ═══ CRÉER ═══
  if(view==='creer') return wrap(
    <div style={{padding:'22px 32px',maxWidth:700}}>
      <h2 style={{fontSize:17,fontWeight:800,margin:'0 0 3px'}}>{$('creer_title')}</h2>
      <p style={{fontSize:12,color:'#777',marginBottom:18}}>{$('creer_sub')}</p>
      <div style={{background:'#0F0F0F',borderRadius:13,padding:22,border:'1px solid rgba(255,255,255,0.07)',marginBottom:12}}>
        <div style={{background:'rgba(201,168,76,0.05)',borderRadius:9,padding:'11px 14px',marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,flexWrap:'wrap',border:'1px solid rgba(201,168,76,0.18)'}}>
          <span style={{fontSize:12,color:'#C9A84C'}}>{$('ia_label')} {$('ia_text')}</span>
          <Btn onClick={handleAI} sm dis={aiLoad}>{aiLoad?$('btn_analyse'):$('btn_suggerer')}</Btn>
        </div>
        <Inp label={$('l_titre')} value={nlF.title} onChange={v=>setNlF(p=>({...p,title:v}))} placeholder={$('p_titre')} req/>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          <Sel label={$('l_cat')} value={nlF.category} onChange={v=>setNlF(p=>({...p,category:v}))} opts={CATS.map(c=>({v:c.id,l:`${c.icon} ${c[lang]}`}))} req/>
          <Sel label={$('l_etat')} value={nlF.condition} onChange={v=>setNlF(p=>({...p,condition:v}))} opts={CONDS.map(c=>({v:c.id,l:c[lang]}))}/>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12}}>
          <Inp label={$('l_qte')} value={nlF.quantity} onChange={v=>setNlF(p=>({...p,quantity:v}))} placeholder={$('p_qte')} type="number" req/>
          <Sel label={$('l_unite')} value={nlF.unit} onChange={v=>setNlF(p=>({...p,unit:v}))} opts={UNITS}/>
          <Inp label={$('l_prix')} value={nlF.price} onChange={v=>setNlF(p=>({...p,price:v}))} placeholder={$('p_prix')} type="number" req/>
        </div>
        <Inp label={$('l_loc')} value={nlF.location} onChange={v=>setNlF(p=>({...p,location:v}))} placeholder={$('p_loc')} req/>
        <div style={{marginBottom:14}}>
          <label style={LS}>{$('l_desc')}</label>
          <textarea value={nlF.description} onChange={e=>setNlF(p=>({...p,description:e.target.value}))} placeholder={$('p_desc')} rows={3} style={{...IS,resize:'vertical',lineHeight:1.6}}/>
        </div>
        <div>
          <label style={LS}>{$('l_photos')}</label>
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            {nlF.photos.map((ph,i)=>(
              <div key={i} style={{width:76,height:76,borderRadius:8,overflow:'hidden',position:'relative',flexShrink:0}}>
                <img src={ph} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                <button onClick={()=>removePhoto(i)} style={{position:'absolute',top:3,right:3,width:16,height:16,borderRadius:'50%',background:'rgba(0,0,0,0.8)',border:'none',cursor:'pointer',color:'#fff',fontSize:9,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center'}}>✕</button>
              </div>
            ))}
            {nlF.photos.length<4&&<label style={{width:76,height:76,borderRadius:8,border:'1.5px dashed rgba(201,168,76,0.3)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',cursor:'pointer',color:'#C9A84C',gap:2,flexShrink:0,background:'rgba(201,168,76,0.03)'}}>
              <input type="file" accept="image/*" multiple style={{display:'none'}} onChange={e=>handlePhotos(e.target.files)}/>
              <span style={{fontSize:18}}>📷</span><span style={{fontSize:8,fontWeight:700,letterSpacing:'0.05em'}}>{$('ajouter')}</span>
            </label>}
          </div>
        </div>
      </div>
      {nlF.title&&<div style={{background:'#0F0F0F',borderRadius:10,padding:14,border:'1px solid rgba(201,168,76,0.22)',marginBottom:12}}>
        <p style={{fontSize:9,fontWeight:700,color:'#C9A84C',margin:'0 0 9px',textTransform:'uppercase',letterSpacing:'0.12em'}}>{$('apercu')}</p>
        <div style={{display:'flex',gap:10,alignItems:'start'}}>
          {nlF.photos[0]&&<img src={nlF.photos[0]} style={{width:52,height:52,borderRadius:7,objectFit:'cover',flexShrink:0}}/>}
          <div style={{flex:1}}>
            <h3 style={{fontSize:13,fontWeight:700,color:'#fff',margin:'0 0 3px'}}>{nlF.title}</h3>
            {nlF.description&&<p style={{fontSize:11,color:'#888',margin:'0 0 6px',lineHeight:1.4}}>{nlF.description}</p>}
            <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
              {nlF.category&&<Tag>{catLabel(nlF.category)}</Tag>}
              {nlF.location&&<Tag bg='rgba(255,255,255,0.04)' tc='#AAA' bd='rgba(255,255,255,0.06)'>📍 {nlF.location}</Tag>}
            </div>
          </div>
          {nlF.price&&<div style={{textAlign:'right',flexShrink:0}}><div style={{fontSize:15,fontWeight:800,color:'#C9A84C'}}>{fmtP(nlF.price)}</div><div style={{fontSize:10,color:'#888'}}>/{nlF.unit}</div></div>}
        </div>
      </div>}
      <div style={{display:'flex',gap:8}}><Btn onClick={handleCreate}>{$('btn_publier')}</Btn><Btn onClick={blankNl} variant="ghost">{$('btn_reset')}</Btn></div>
    </div>
  );

  // ═══ MESSAGES ═══
  if(view==='messages') {
    const myC=convos.filter(c=>user&&(c.buyerId===user.id||c.sellerId===user.id));
    const ac=myC.find(c=>c.id===acId);
    const acL=ac?lists.find(l=>l.id===ac.listingId):null;
    const other=ac?getUser(ac.buyerId===user.id?ac.sellerId:ac.buyerId):null;
    return wrap(
      <div style={{display:'flex',height:'calc(100vh)',overflow:'hidden'}}>
        <div style={{width:270,borderRight:'1px solid rgba(255,255,255,0.06)',display:'flex',flexDirection:'column',flexShrink:0}}>
          <div style={{padding:'18px 16px 12px',borderBottom:'1px solid rgba(255,255,255,0.06)'}}><h2 style={{fontSize:15,fontWeight:800,margin:0}}>{$('msg_title')}</h2><p style={{fontSize:10,color:'#666',margin:'3px 0 0'}}>{myC.length} {myC.length!==1?$('conv_p'):$('conv_s')}</p></div>
          <div style={{flex:1,overflow:'auto'}}>
            {myC.length===0?<div style={{padding:28,textAlign:'center',color:'#777'}}><div style={{fontSize:28,marginBottom:7}}>💬</div><p style={{fontSize:12,margin:'0 0 4px'}}>{$('no_conv')}</p><p style={{fontSize:11,color:'#555',margin:0}}>{$('no_conv_sub')}</p></div>
            :myC.map(c=>{
              const ou=getUser(c.buyerId===user.id?c.sellerId:c.buyerId);
              const li=lists.find(l=>l.id===c.listingId);
              const last=c.messages[c.messages.length-1];
              const nr=c.messages.filter(m=>m.senderId!==user.id&&!m.read).length;
              const iA=c.id===acId;
              return (
                <button key={c.id} onClick={()=>openConvo(c.id)} style={{display:'block',width:'100%',padding:'11px 14px',border:'none',background:iA?'rgba(201,168,76,0.07)':'transparent',textAlign:'left',cursor:'pointer',borderLeft:iA?'2px solid #C9A84C':'2px solid transparent',transition:'all 0.12s'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:2}}>
                    <span style={{fontSize:12,fontWeight:nr?700:500,color:iA?'#E2C167':'#BBB',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:150}}>{ou?.nom}</span>
                    <span style={{fontSize:9,color:'#666',flexShrink:0,marginLeft:4}}>{last?fmtH(last.date):''}</span>
                  </div>
                  <div style={{fontSize:10,color:'#777',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',marginBottom:2}}>{li?.title}</div>
                  {last&&<div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <span style={{fontSize:10,color:nr?'#C9A84C':'#555',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{last.senderId===user.id?$('vous'):''}{last.text}</span>
                    {nr>0&&<span style={{background:'#E05252',color:'#fff',borderRadius:9,padding:'1px 5px',fontSize:9,fontWeight:800,flexShrink:0,marginLeft:4}}>{nr}</span>}
                  </div>}
                </button>
              );
            })}
          </div>
        </div>
        <div style={{flex:1,display:'flex',flexDirection:'column',minWidth:0}}>
          {!ac?<div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',color:'#666'}}>
            <div style={{opacity:0.2,marginBottom:12}}><CibleLogo size={50}/></div>
            <p style={{fontSize:13,color:'#666',margin:0}}>{$('select_conv')}</p>
          </div>:<>
            <div style={{padding:'12px 18px',borderBottom:'1px solid rgba(255,255,255,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0}}>
              <div><div style={{fontSize:13,fontWeight:700,color:'#fff'}}>{other?.nom}</div><div style={{fontSize:10,color:'#C9A84C'}}>{other?.entreprise}</div></div>
              {acL&&<button onClick={()=>go('detail',acL.id)} style={{background:'rgba(201,168,76,0.06)',border:'1px solid rgba(201,168,76,0.18)',borderRadius:8,padding:'5px 10px',cursor:'pointer',textAlign:'right'}}>
                <div style={{fontSize:9,color:'#888',textAlign:'left'}}>{$('ann_label')}</div>
                <div style={{fontSize:11,fontWeight:600,color:'#C9A84C',maxWidth:180,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{acL.title}</div>
              </button>}
            </div>
            <div style={{flex:1,overflow:'auto',padding:'14px 18px',display:'flex',flexDirection:'column',gap:9}}>
              {ac.messages.length===0&&<div style={{textAlign:'center',color:'#666',padding:16,fontSize:12}}>{$('demarrer')}</div>}
              {ac.messages.map(m=>{
                const me=m.senderId===user.id;
                return <div key={m.id} style={{display:'flex',flexDirection:'column',alignItems:me?'flex-end':'flex-start'}}>
                  <div style={{background:me?'rgba(201,168,76,0.13)':'#161616',border:`1px solid ${me?'rgba(201,168,76,0.25)':'rgba(255,255,255,0.07)'}`,borderRadius:me?'12px 12px 2px 12px':'12px 12px 12px 2px',padding:'9px 13px',maxWidth:'70%'}}>
                    <p style={{margin:0,fontSize:13,color:me?'#E2C167':'#DDD',lineHeight:1.5}}>{m.text}</p>
                  </div>
                  <span style={{fontSize:9,color:'#555',marginTop:3}}>{fmtH(m.date)}{me&&m.read?$('lu'):''}</span>
                </div>;
              })}
              <div ref={msgEnd}/>
            </div>
            <div style={{padding:'10px 14px',borderTop:'1px solid rgba(255,255,255,0.06)',display:'flex',gap:8,flexShrink:0}}>
              <input value={msgText} onChange={e=>setMsgText(e.target.value)} onKeyDown={e=>e.key==='Enter'&&!e.shiftKey&&sendMsg()}
                placeholder={$('p_msg')}
                style={{flex:1,padding:'9px 13px',background:'#0F0F0F',border:'1px solid rgba(255,255,255,0.1)',borderRadius:8,fontSize:13,color:'#fff',outline:'none',fontFamily:'inherit'}}/>
              <Btn onClick={sendMsg} dis={!msgText.trim()}>▶</Btn>
            </div>
          </>}
        </div>
      </div>
    );
  }

  // ═══ FAVORIS ═══
  if(view==='favoris') {
    const fl=lists.filter(l=>favs.includes(l.id));
    return wrap(<div style={{padding:'22px 32px'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:18}}>
        <div><h2 style={{fontSize:17,fontWeight:800,margin:'0 0 2px'}}>{$('fav_title')}</h2><p style={{fontSize:11,color:'#777',margin:0}}>{fl.length} {fl.length!==1?$('ann_p'):$('ann_s')}</p></div>
      </div>
      {fl.length===0
        ?<div style={{textAlign:'center',padding:50,background:'#0F0F0F',borderRadius:12,border:'1px solid rgba(255,255,255,0.07)'}}>
          <div style={{fontSize:36,marginBottom:8}}>❤️</div><h3 style={{color:'#BBB',margin:'0 0 5px'}}>{$('no_fav')}</h3>
          <p style={{color:'#777',margin:'0 0 14px',fontSize:12}}>{$('no_fav_sub')}</p><Btn onClick={()=>setView('annonces')}>{$('btn_parc_ann')}</Btn>
        </div>
        :<div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:9}}>
          {fl.map(l=><Card key={l.id} listing={l} seller={getUser(l.sellerId)} onOpen={id=>go('detail',id)} isFav={true} onFav={toggleFav} lang={lang}/>)}
        </div>
      }
    </div>);
  }

  // ═══ MES ANNONCES ═══
  if(view==='mes-annonces') {
    const my=lists.filter(l=>l.sellerId===user.id);
    return wrap(<div style={{padding:'22px 32px'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <div><h2 style={{fontSize:17,fontWeight:800,margin:'0 0 2px'}}>{$('mes_ann')}</h2><p style={{fontSize:11,color:'#777',margin:0}}>{my.length} {my.length!==1?$('ann_p'):$('ann_s')}</p></div>
        <Btn onClick={()=>setView('creer')}>{$('btn_nouvelle')}</Btn>
      </div>
      {my.length===0
        ?<div style={{textAlign:'center',padding:50,background:'#0F0F0F',borderRadius:12,border:'1px solid rgba(255,255,255,0.07)'}}>
          <div style={{fontSize:36,marginBottom:8}}>📦</div><h3 style={{color:'#BBB',margin:'0 0 5px'}}>{$('no_ann')}</h3>
          <p style={{color:'#777',margin:'0 0 14px',fontSize:12}}>{$('no_ann_sub')}</p><Btn onClick={()=>setView('creer')}>{$('btn_premiere')}</Btn>
        </div>
        :<div style={{display:'flex',flexDirection:'column',gap:7}}>
          {my.map(l=>{
            const cc=convos.filter(c=>c.listingId===l.id).length;
            return <div key={l.id} style={{background:'#0F0F0F',borderRadius:10,padding:'12px 16px',border:'1px solid rgba(255,255,255,0.07)',display:'flex',justifyContent:'space-between',alignItems:'center',gap:10}}>
              <div style={{display:'flex',gap:10,alignItems:'center',flex:1,minWidth:0}}>
                <div style={{width:40,height:40,borderRadius:8,overflow:'hidden',flexShrink:0,background:catBg(l.category),display:'flex',alignItems:'center',justifyContent:'center',fontSize:18}}>
                  {l.photos?.[0]?<img src={l.photos[0]} style={{width:'100%',height:'100%',objectFit:'cover'}}/>:CATS.find(c=>c.id===l.category)?.icon}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <h3 style={{fontSize:12,fontWeight:600,color:'#fff',margin:'0 0 4px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{l.title}</h3>
                  <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                    <Tag>{catLabel(l.category)}</Tag>
                    <Tag bg='rgba(255,255,255,0.04)' tc='#888' bd='rgba(255,255,255,0.06)'>👁 {l.views}</Tag>
                    {cc>0&&<Tag>💬 {cc}</Tag>}
                  </div>
                </div>
              </div>
              <div style={{textAlign:'right',flexShrink:0}}>
                <div style={{fontSize:15,fontWeight:800,color:'#C9A84C'}}>{fmtP(l.price)}<span style={{fontSize:10,color:'#888',fontWeight:400}}>/{l.unit}</span></div>
                <div style={{fontSize:10,color:'#888',margin:'2px 0 6px'}}>Qté: {l.quantity} · {fmtD(l.date,lang)}</div>
                <div style={{display:'flex',gap:5,justifyContent:'flex-end'}}>
                  <Btn onClick={()=>go('detail',l.id)} sm variant="ghost">{$('btn_voir')}</Btn>
                  <Btn onClick={()=>handleDelete(l.id)} sm variant="red">{$('btn_suppr')}</Btn>
                </div>
              </div>
            </div>;
          })}
        </div>
      }
    </div>);
  }

  // ═══ TARIFS ═══
  if(view==='tarifs') {
    const content = (
      <div style={{padding:user?'28px 32px':'0', maxWidth:user?960:'100%'}}>
        <div style={{textAlign:'center',marginBottom:36,paddingTop:user?0:20}}>
          {!user&&<div style={{marginBottom:14,cursor:'pointer'}} onClick={()=>setView('login')}>
            <div style={{display:'inline-flex',alignItems:'center',gap:8,marginBottom:10}}><CibleLogo size={26}/><span style={{fontWeight:900,fontSize:17,letterSpacing:'0.04em'}}><span style={{color:'#fff'}}>CIBLE</span><span style={{background:'linear-gradient(90deg,#E2C167,#9A7A2E)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>MAX</span></span></div>
          </div>}
          <h2 style={{fontSize:26,fontWeight:900,margin:'0 0 8px',letterSpacing:'-0.02em'}}>{$('tarifs_title')}</h2>
          <p style={{color:'#888',fontSize:13,margin:'0 0 14px'}}>{$('tarifs_sub')}</p>
          <div style={{display:'inline-flex',alignItems:'center',gap:6,background:'rgba(74,222,128,0.08)',border:'1px solid rgba(74,222,128,0.2)',borderRadius:20,padding:'5px 14px',fontSize:13,color:'#4ADE80',fontWeight:600}}>{$('no_card')}</div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:14,marginBottom:32}}>
          {plans.map(plan=>(
            <div key={plan.id} style={{background:plan.highlight?'#0F0F0F':'#0A0A0A',borderRadius:14,padding:26,border:plan.highlight?`1px solid ${C.orBd}`:'1px solid rgba(255,255,255,0.07)',position:'relative',boxShadow:plan.highlight?`0 0 40px rgba(201,168,76,0.1)`:'',display:'flex',flexDirection:'column'}}>
              {plan.highlight&&<div style={{position:'absolute',top:-12,left:'50%',transform:'translateX(-50%)',background:'linear-gradient(135deg,#E2C167,#9A7A2E)',color:'#080808',borderRadius:20,padding:'4px 14px',fontSize:11,fontWeight:800,whiteSpace:'nowrap'}}>{lang==='fr'?'⭐ PLUS POPULAIRE':'⭐ MOST POPULAR'}</div>}
              {user&&userPlan===plan.id&&<div style={{position:'absolute',top:12,right:12}}><Tag>{$('plan_actuel')}</Tag></div>}
              <div style={{marginBottom:18}}>
                <div style={{fontSize:15,fontWeight:800,color:plan.highlight?C.orL:'#fff',marginBottom:5}}>{plan.nom[lang]}</div>
                <div style={{marginBottom:7}}>
                  {plan.prix===null
                    ?<span style={{fontSize:22,fontWeight:900,color:'#fff'}}>{$('sur_mesure')}</span>
                    :<><span style={{fontSize:30,fontWeight:900,color:plan.highlight?C.orL:'#fff'}}>{plan.prix===0?$('gratuit_label'):`${plan.prix.toFixed(2)} $`}</span>
                      {plan.prix>0&&<span style={{fontSize:12,color:'#888',marginLeft:4}}>{$('mois')}</span>}</>
                  }
                </div>
                {plan.badge&&<div style={{display:'inline-flex',alignItems:'center',gap:5,background:'rgba(74,222,128,0.1)',border:'1px solid rgba(74,222,128,0.25)',borderRadius:12,padding:'3px 10px',fontSize:11,color:'#4ADE80',fontWeight:600}}>✓ {plan.badge[lang]}</div>}
                <p style={{fontSize:12,color:'#888',margin:'8px 0 0',lineHeight:1.5}}>{plan.desc[lang]}</p>
              </div>
              <div style={{flex:1,marginBottom:20}}>
                {plan.features.map((f,i)=>(
                  <div key={i} style={{display:'flex',alignItems:'center',gap:9,padding:'5px 0',borderBottom:'1px solid rgba(255,255,255,0.04)'}}>
                    <span style={{fontSize:13,color:f.ok?'#4ADE80':'#555',flexShrink:0}}>{f.ok?'✓':'✗'}</span>
                    <span style={{fontSize:12,color:f.ok?'#BBB':'#555'}}>{f[lang]}</span>
                  </div>
                ))}
              </div>
              <button onClick={()=>choisirPlan(plan.id)}
                style={{width:'100%',padding:'11px',borderRadius:9,fontSize:13,fontWeight:700,cursor:'pointer',border:'none',
                  background:plan.highlight?'linear-gradient(135deg,#E2C167,#9A7A2E)':user&&userPlan===plan.id?'rgba(255,255,255,0.05)':'rgba(255,255,255,0.07)',
                  color:plan.highlight?'#080808':user&&userPlan===plan.id?'#888':'#BBB',transition:'opacity 0.15s'}}
                onMouseEnter={e=>e.currentTarget.style.opacity='0.85'}
                onMouseLeave={e=>e.currentTarget.style.opacity='1'}>
                {user&&userPlan===plan.id?(lang==='fr'?'✓ Plan actuel':'✓ Current plan'):plan.cta[lang]}
              </button>
            </div>
          ))}
        </div>
        <div style={{background:'#0A0A0A',borderRadius:12,padding:22,border:'1px solid rgba(255,255,255,0.06)',marginBottom:16}}>
          <h3 style={{fontSize:13,fontWeight:700,color:'#BBB',margin:'0 0 14px',textTransform:'uppercase',letterSpacing:'0.08em'}}>{$('faq_title')}</h3>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            {[[$('faq1q'),$('faq1r')],[$('faq2q'),$('faq2r')],[$('faq3q'),$('faq3r')],[$('faq4q'),$('faq4r')]].map(([q,r],i)=>(
              <div key={i} style={{padding:14,background:'rgba(255,255,255,0.02)',borderRadius:8,border:'1px solid rgba(255,255,255,0.04)'}}>
                <div style={{fontSize:12,fontWeight:700,color:'#C9A84C',marginBottom:5}}>{q}</div>
                <div style={{fontSize:12,color:'#888',lineHeight:1.55}}>{r}</div>
              </div>
            ))}
          </div>
        </div>
        {!user&&<div style={{textAlign:'center',paddingBottom:20}}>
          <button onClick={()=>setView('login')} style={{background:'none',border:'none',color:'#888',fontSize:12,cursor:'pointer'}}>← {lang==='fr'?'Retour à la connexion':'Back to sign in'}</button>
        </div>}
      </div>
    );
    return user ? wrap(content) : authWrap(<div style={{width:'100%',maxWidth:960,position:'relative',zIndex:1}}>{content}</div>);
  }

  // ═══ PROFIL ═══
  if(view==='profil') {
    const my=lists.filter(l=>l.sellerId===user.id);
    return wrap(<div style={{padding:'22px 32px',maxWidth:600}}>
      <h2 style={{fontSize:17,fontWeight:800,margin:'0 0 16px'}}>{$('profil_title')}</h2>
      <div style={{background:'#0F0F0F',borderRadius:13,border:'1px solid rgba(255,255,255,0.07)',overflow:'hidden',marginBottom:10}}>
        <div style={{padding:'18px 20px',display:'flex',alignItems:'center',gap:12,borderBottom:'1px solid rgba(255,255,255,0.06)',background:'linear-gradient(135deg,#0F0F0F,#161616)'}}>
          <div style={{width:48,height:48,background:'linear-gradient(135deg,#E2C167,#9A7A2E)',borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',fontSize:19,fontWeight:900,color:'#060606',flexShrink:0}}>{user.nom?.charAt(0)}</div>
          <div style={{flex:1}}>
            <div style={{color:'#fff',fontSize:16,fontWeight:800}}>{user.nom}</div>
            <div style={{color:'#C9A84C',fontSize:11,fontWeight:600,marginTop:2}}>{user.entreprise}</div>
            <div style={{color:'#777',fontSize:10,marginTop:2}}>📍 {user.ville||'—'}</div>
          </div>
          <div style={{background:userPlan==='pro'?C.orBg:'rgba(255,255,255,0.04)',border:`1px solid ${userPlan==='pro'?C.orBd:'rgba(255,255,255,0.07)'}`,borderRadius:8,padding:'6px 12px',cursor:'pointer',textAlign:'center'}} onClick={()=>setView('tarifs')}>
            <div style={{fontSize:11,fontWeight:700,color:userPlan==='pro'?C.orL:'#888'}}>{userPlan==='pro'?$('plan_pro'):$('plan_gratuit')}</div>
            <div style={{fontSize:9,color:userPlan==='pro'?C.or:'#666',marginTop:1}}>{userPlan==='pro'?$('jours_restants'):$('passer_pro')}</div>
          </div>
        </div>
        <div style={{padding:'14px 20px',display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          <div><div style={LS}>{$('tel_label')}</div><div style={{fontSize:13,color:'#BBB'}}>{user.telephone||'—'}</div></div>
          <div><div style={LS}>{$('l_courriel')}</div><div style={{fontSize:13,color:'#BBB'}}>{user.email}</div></div>
        </div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:7,marginBottom:14}}>
        {[{l:$('stat_ann'),v:my.length,i:'📋'},{l:$('stat_vues'),v:my.reduce((s,l)=>s+l.views,0),i:'👁'},{l:$('stat_fav'),v:favs.length,i:'❤️'},{l:$('stat_val'),v:`${my.reduce((s,l)=>s+l.price*l.quantity,0).toFixed(0)} $`,i:'💰'}].map(st=>(
          <div key={st.l} style={{background:'#0F0F0F',borderRadius:10,padding:13,border:'1px solid rgba(255,255,255,0.07)',textAlign:'center'}}>
            <div style={{fontSize:18,marginBottom:4}}>{st.i}</div>
            <div style={{fontSize:16,fontWeight:900,color:'#C9A84C'}}>{st.v}</div>
            <div style={{fontSize:9,color:'#777',marginTop:2,textTransform:'uppercase',letterSpacing:'0.06em'}}>{st.l}</div>
          </div>
        ))}
      </div>
      <div style={{display:'flex',gap:8}}>
        <Btn onClick={()=>setView('creer')}>{$('btn_creer_ann')}</Btn>
        {userPlan==='gratuit'&&<Btn onClick={()=>setView('tarifs')} variant="ghost">{$('btn_passer_pro')}</Btn>}
      </div>
    </div>);
  }

  // ═══ DÉTAIL ═══
  if(view==='detail'&&selL) {
    const seller=getUser(selL.sellerId);
    const isOwn=selL.sellerId===user?.id;
    const hasPhotos=selL.photos?.length>0;
    return wrap(<div style={{padding:'22px 32px',maxWidth:720}}>
      <button onClick={()=>setView('annonces')} style={{background:'none',border:'none',color:'#C9A84C',fontWeight:600,cursor:'pointer',fontSize:12,marginBottom:14,padding:0}}>{$('btn_retour')}</button>
      <div style={{background:'#0F0F0F',borderRadius:13,border:'1px solid rgba(255,255,255,0.07)',overflow:'hidden'}}>
        {hasPhotos&&<div style={{position:'relative',height:200,background:'#000',overflow:'hidden'}}>
          <img src={selL.photos[gallery]} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
          {selL.photos.length>1&&<>
            <button onClick={()=>setGallery(g=>(g-1+selL.photos.length)%selL.photos.length)} style={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',width:28,height:28,borderRadius:'50%',background:'rgba(0,0,0,0.7)',border:'none',cursor:'pointer',color:'#fff',fontSize:14}}>‹</button>
            <button onClick={()=>setGallery(g=>(g+1)%selL.photos.length)} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',width:28,height:28,borderRadius:'50%',background:'rgba(0,0,0,0.7)',border:'none',cursor:'pointer',color:'#fff',fontSize:14}}>›</button>
            <div style={{position:'absolute',bottom:8,left:'50%',transform:'translateX(-50%)',display:'flex',gap:5}}>
              {selL.photos.map((_,i)=><button key={i} onClick={()=>setGallery(i)} style={{width:5,height:5,borderRadius:'50%',border:'none',cursor:'pointer',background:i===gallery?'#E2C167':'rgba(255,255,255,0.4)',padding:0}}/>)}
            </div>
          </>}
        </div>}
        {!hasPhotos&&<div style={{height:100,background:catBg(selL.category),display:'flex',alignItems:'center',justifyContent:'center'}}><span style={{fontSize:44,opacity:0.2}}>{CATS.find(c=>c.id===selL.category)?.icon}</span></div>}
        <div style={{padding:'18px 24px',display:'flex',justifyContent:'space-between',alignItems:'start',gap:12,borderBottom:'1px solid rgba(255,255,255,0.06)'}}>
          <div>
            <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:7}}>
              <span style={{background:`${condCol(selL.condition)}18`,color:condCol(selL.condition),border:`1px solid ${condCol(selL.condition)}30`,padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:700}}>{condLabel(selL.condition)}</span>
              {favs.includes(selL.id)&&<span style={{background:'rgba(229,82,82,0.1)',color:'#F87171',border:'1px solid rgba(229,82,82,0.2)',padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:700}}>❤️ {lang==='fr'?'Favori':'Favorite'}</span>}
            </div>
            <h1 style={{color:'#fff',fontSize:18,fontWeight:800,margin:'0 0 4px'}}>{selL.title}</h1>
            <div style={{color:'#777',fontSize:10}}>{$('publie_le')} {fmtD(selL.date,lang)} · {selL.views} {$('vues')}</div>
          </div>
          <div style={{textAlign:'right',flexShrink:0}}>
            <div style={{fontSize:24,fontWeight:900,color:'#C9A84C'}}>{fmtP(selL.price)}</div>
            <div style={{fontSize:10,color:'#777'}}>{$('par')} {selL.unit}</div>
            <div style={{fontSize:11,color:'#BBB',fontWeight:600,marginTop:2}}>{selL.quantity} {selL.unit} {$('disponibles')}</div>
          </div>
        </div>
        <div style={{padding:'18px 24px'}}>
          <div style={{display:'flex',gap:5,flexWrap:'wrap',marginBottom:14}}>
            <Tag>{catLabel(selL.category)}</Tag>
            <Tag bg='rgba(255,255,255,0.04)' tc='#AAA' bd='rgba(255,255,255,0.06)'>📍 {selL.location}</Tag>
          </div>
          <div style={{fontSize:9,fontWeight:700,color:'#777',textTransform:'uppercase',letterSpacing:'0.09em',marginBottom:6}}>{lang==='fr'?'Description':'Description'}</div>
          <p style={{fontSize:13,color:'#BBB',lineHeight:1.75,margin:'0 0 16px'}}>{selL.description}</p>
          <div style={{background:'rgba(201,168,76,0.05)',borderRadius:9,padding:13,marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,border:'1px solid rgba(201,168,76,0.15)'}}>
            <div><div style={{fontSize:9,fontWeight:700,color:'#C9A84C',textTransform:'uppercase',letterSpacing:'0.1em'}}>{$('valeur_est')}</div><div style={{fontSize:20,fontWeight:900,color:'#E2C167',marginTop:3}}>{fmtP(selL.price*selL.quantity)}</div></div>
            <div style={{fontSize:11,color:'#C9A84C'}}>{selL.quantity} {selL.unit} × {fmtP(selL.price)}</div>
          </div>
          <div style={{borderTop:'1px solid rgba(255,255,255,0.06)',paddingTop:14}}>
            <div style={{fontSize:9,fontWeight:700,color:'#777',textTransform:'uppercase',letterSpacing:'0.09em',marginBottom:11}}>{$('vendeur')}</div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,flexWrap:'wrap'}}>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <div style={{width:38,height:38,background:'linear-gradient(135deg,#E2C167,#9A7A2E)',borderRadius:9,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:900,color:'#060606',flexShrink:0}}>{seller?.nom?.charAt(0)}</div>
                <div><div style={{fontSize:13,fontWeight:700,color:'#fff'}}>{seller?.nom}</div><div style={{fontSize:10,color:'#888'}}>{seller?.entreprise} · 📍 {seller?.ville}</div></div>
              </div>
              <div style={{display:'flex',gap:7,flexWrap:'wrap'}}>
                <Btn onClick={()=>toggleFav(selL.id)} variant="ghost" sm>{favs.includes(selL.id)?$('btn_sauve'):$('btn_sauv')}</Btn>
                {!isOwn&&<Btn onClick={()=>contactSeller(selL)}>{$('btn_contacter')}</Btn>}
                {isOwn&&<Tag>{$('votre_ann')}</Tag>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);
  }

  return wrap(<div style={{padding:40,color:'#777',fontSize:13}}>Vue introuvable.</div>);
}
